module.exports = __webpack_public_path__ + "img/intro2.981c6abd.png";